module.exports = __webpack_public_path__ + "img/img-mask.10eb0989.png";